import React, { Component } from "react";
import { connect } from "../../utils";

class TextView extends Component {
  renderText = (value, containerPadding, lineHeight, letterSpacing) => {
    return (
      <div
        style={{
          padding: containerPadding,
          lineHeight,
          letterSpacing,
          width: "100%",
          textAlign: "left"
        }}
        dangerouslySetInnerHTML={{ __html: value }}
      />
    );
  };
  renderTextLink = (
    value,
    containerPadding,
    lineHeight,
    letterSpacing,
    href
  ) => {
    return (
      <a
        href={href.url}
        target={href.target}
        style={{
          padding: containerPadding,
          lineHeight,
          letterSpacing,
          width: "100%",
          textAlign: "left",
          textDecoration: "none"
        }}
      >
        <div dangerouslySetInnerHTML={{ __html: value }} />
      </a>
    );
  };
  render() {
    const { id, layoutState } = this.props;
    const {
      containerPadding,
      text,
      lineHeight,
      backgroundColor,
      letterSpacing,
      href,
      isLink
    } = layoutState.getItemJS(id).props.values;
    const children = isLink
      ? this.renderTextLink(
          text,
          containerPadding,
          lineHeight,
          letterSpacing,
          href
        )
      : this.renderText(text, containerPadding, lineHeight, letterSpacing);
    return (
      <div
        style={{
          boxSizing: "border-box",
          position: "relative",
          height: "100%",
          backgroundColor: backgroundColor,
          display: "flex",
          flex: 1
        }}
      >
        {children}
      </div>
    );
  }
}
export default connect("layoutState")(TextView);



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Layout/TextView.js